import React, { useState } from 'react';
import RTButton from '../common/RTButton';
import PaymentReceiptPrint from './PaymentReceiptPrint';
import './PaymentSuccessModal.css';

const PaymentSuccessModal = ({ 
  isOpen, 
  onClose, 
  paymentData,
  onNavigateToPayments 
}) => {
  const [showReceipt, setShowReceipt] = useState(false);

  if (!isOpen || !paymentData) return null;

  const {
    payment_created,
    payment,
    invoices_updated,
    total_amount_processed,
    remaining_balance,
    pg_details,
    payment_date,
    payment_method,
    reference_number
  } = paymentData;

  // Use payment_created if available, otherwise fallback to payment
  const paymentInfo = payment_created || payment;

  const handlePrintReceipt = () => {
    setShowReceipt(true);
  };

  const handleReceiptPrinted = () => {
    setShowReceipt(false);
    onClose();
    onNavigateToPayments();
  };

  const handleClose = () => {
    onClose();
    onNavigateToPayments();
  };

  const handleViewPayment = () => {
    onClose();
    // Navigate to payment view screen with payment ID
    window.location.href = `/payments/${paymentInfo?.payment_id}/view`;
  };

  if (showReceipt) {
    return (
      <PaymentReceiptPrint
        paymentId={paymentInfo?.payment_id}
        onClose={handleReceiptPrinted}
      />
    );
  }

  return (
    <div className="payment-success-overlay">
      <div className="payment-success-modal">
        <div className="payment-success-header">
          <div className="success-icon">✓</div>
          <h2>Payment Successful!</h2>
          <p className="receipt-number">Receipt #{paymentInfo?.payment_id}</p>
        </div>

        <div className="payment-success-content">
          <div className="payment-summary">
            <div className="summary-grid">
              <div className="summary-item">
                <span className="label">Paying Guest:</span>
                <span className="value">{pg_details?.name}</span>
              </div>
              <div className="summary-item">
                <span className="label">Total Amount Processed:</span>
                <span className="value amount">₹{total_amount_processed?.toFixed(2)}</span>
              </div>
              <div className="summary-item">
                <span className="label">Payment Method:</span>
                <span className="value">{payment_method}</span>
              </div>
              <div className="summary-item">
                <span className="label">Payment Date:</span>
                <span className="value">{new Date(payment_date).toLocaleDateString()}</span>
              </div>
              {reference_number && (
                <div className="summary-item">
                  <span className="label">Reference Number:</span>
                  <span className="value">{reference_number}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="payment-success-actions">
          <RTButton 
            variant="secondary" 
            onClick={handleClose}
            className="close-button"
          >
            Close
          </RTButton>
          <RTButton 
            variant="outline" 
            onClick={handleViewPayment}
            className="view-payment-button"
          >
            View Payment
          </RTButton>
          <RTButton 
            variant="primary" 
            onClick={handlePrintReceipt}
            className="print-button"
          >
            Print Receipt
          </RTButton>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessModal;
